import {useContext} from 'react';

import {SystemContext} from './system-context';
import {SystemContextType} from './system-context-type';

export function useSystem(): SystemContextType {
    return useContext<SystemContextType>(SystemContext);
}
